import { useQuery } from "@tanstack/react-query";
import { REFRESH_INTERVAL } from "../models/constants";
import { getFurnaceBillets } from "../repositories/MillSetupRepository";

export const useFurnaceBillets = () => {
	return useQuery({
		queryKey: ["millSetup", "furnaceBillets"],
		queryFn: ({ signal }) => getFurnaceBillets(signal),
		refetchInterval: REFRESH_INTERVAL,
		staleTime: REFRESH_INTERVAL - 1000,
		retry: false,
		refetchOnWindowFocus: false,
	});
};
